import type { DemoScript } from "../types";

/**
 * O grupo de um passo: os dois primeiros pedaços do id (`tasks-modal-title` →
 * `tasks-modal`). É o que separa uma camada da seguinte no mesmo roteiro —
 * `tasks-modal-*` é o planejamento, `tasks-roteiro-*` é o roteiro.
 */
function group(id: string): string {
  return id.split("-").slice(0, 2).join("-");
}

/**
 * Para onde o "fechar" leva quando não há de onde voltar.
 *
 * Na página quem abriu foi a pessoa, e fechar devolve ao passo de onde ela
 * saiu. Na home quem abriu foi o roteiro, que é uma linha reta: fechar é
 * pular o resto dessa camada e seguir dali. Sem isso o X era desenho — a
 * pessoa clicava e o modal continuava aberto, porque quem o mantinha aberto
 * era o passo, e o passo não tinha mudado.
 *
 * O último passo do roteiro devolve a si mesmo: não há para onde seguir, e
 * voltar ao começo faria a demo recomeçar por causa de um clique em "fechar".
 */
export function stepAfterOverlay(script: DemoScript, currentIndex: number): number {
  const current = script[currentIndex];
  if (!current) return currentIndex;

  const atual = group(current.id);
  for (let index = currentIndex + 1; index < script.length; index += 1) {
    const step = script[index];
    if (step && group(step.id) !== atual) return index;
  }
  return currentIndex;
}
